
/**
 * 会员等级铭牌（MemberNameplate Design System V2）
 * 18 级材质：普通→白银→黄金→铂金→钻石→黑金→星耀→臻选→首席
 * 浅色底 + 材质描边/文字；Lv13+ 扫光（黑金 Lv11/12 静态）。
 * name 由调用处拼好，含 Lv 数值（如 "Lv.1 普通会员 I"）。
 */
export default {
  name: 'MemberNameplate',
  props: {
    level: { type: Number, default: 1 },
    name: { type: String, default: '' }
  },
  computed: {
    lvClass () {
      return 'np-lv' + Math.min(18, Math.max(1, this.level || 1))
    }
  }
}
